import React, { useEffect, useState } from 'react'
import { GetCurrent } from '../../Api/getData.jsx';
import Engine1 from './Engine1';
import Inclino from './Inclino';
import Maps from './AvgData/Maps';
import { useSearchParams } from 'react-router-dom';
import { useDataFilter } from '../../components/global.jsx';
import FuelLevel1 from './FuelLevel1';
import { HiChartBar, HiClock, HiMap } from 'react-icons/hi';

const Sensor = () => {

    useEffect(() => {
        document.title = "NextSense - Dashboard";
    }, []);

    useDataFilter();

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDataGetCurrent = async () => {
            try {
                setLoading(true);
                const res = await GetCurrent(
                    {
                        AccountId: KodeCabang,
                        ObjectCode: ShipCode
                    }
                );
                setDataSource(res);
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };

        fetchDataGetCurrent();

        const intervalId = setInterval(fetchDataGetCurrent, 1800000);

        return () => clearInterval(intervalId);
    }, [KodeCabang, ShipCode]);

    // Group data by DisplayGroupName and convert to array
    const groupedData = dataSource && Object.entries(
        dataSource.reduce((groups, item) => {
            const groupName = item.DisplayGroupName || 'Other';
            if (!groups[groupName]) {
                groups[groupName] = [];
            }
            groups[groupName].push(item);
            return groups;
        }, {})
    ).map(([groupName, items]) => ({
        groupName,
        items
    }));

    // Debug: Log grouped data structure
    // console.log('Grouped Data:', groupedData);
    // console.log('Available Groups:', groupedData?.map(group => group.groupName) || []);

    const dataEngine = groupedData.filter((item) => item.groupName.startsWith("ENGINE"));
    const dataLevel = groupedData.filter((item) => item.groupName.startsWith("FUEL"));
    // const dataInclino = groupedData.filter((item) => item.groupName.startsWith("INCLINO"));

    // const level = dataSource && dataSource.filter((item) =>
    //     item?.SensorCode?.startsWith("LVL")).map((item, index) =>
    //         ({ ...item, key: index + 1 }));

    const LastDateMap = dataSource.length > 0 ? dataSource[1].RefDate : "";

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4 flex items-center justify-center">
                <div className="flex flex-col items-center space-y-4">
                    <div className="w-16 h-16 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin"></div>
                    <p className="text-gray-600 font-medium">Loading sensor data...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4">
            <div className="space-y-6">
                {/* Header Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                        <div className="flex items-center space-x-4">
                            <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-xl flex items-center justify-center shadow-lg">
                                <HiChartBar className="w-6 h-6 text-white" />
                            </div>
                            <div>
                                <h1 className="lg:text-3xl text-2xl font-bold gradient-text">Sensor Dashboard</h1>
                                <p className="text-gray-600 mt-1 ">Real-time sensor monitoring and analytics</p>
                            </div>
                        </div>

                        <div className="flex flex-col lg:flex-row lg:items-center gap-2">
                            <div className="flex items-center space-x-2 px-4 py-2 bg-success-50 rounded-xl border border-success-200">
                                <div className="w-3 h-3 bg-success-500 rounded-full animate-pulse"></div>
                                <span className="text-sm font-semibold text-success-700">Live Data</span>
                            </div>
                            <div className="flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-xl border border-blue-200">
                                <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                                <span className="text-sm font-semibold text-blue-700">{dataSource.length} Sensors</span>
                            </div>
                            {LastDateMap && (
                                <div className="flex items-center space-x-2 px-4 py-2 bg-gray-50 rounded-xl border border-gray-200">
                                    <HiClock className="w-4 h-4 text-gray-500" />
                                    <div>
                                        <p className="text-xs text-gray-500 font-medium">Last Update</p>
                                        <p className="text-sm font-semibold text-gray-700">
                                            {new Date(LastDateMap).toLocaleString('id-ID', {
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit'
                                            })}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Maps Section */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                    <div className="flex items-center space-x-3 mb-6">
                        <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center">
                            <HiMap className="w-4 h-4 text-green-600" />
                        </div>
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">Vessel Location</h2>
                            <p className="text-sm text-gray-600">Current position and navigation data</p>
                        </div>
                    </div>
                    <Maps dataSource={dataSource} />
                </div>

                {/* Engine Sensors */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center">
                                <HiLightningBolt className="w-4 h-4 text-red-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">Engine 1</h3>
                                <p className="text-sm text-gray-600">RPM and temperature monitoring</p>
                            </div>
                        </div>
                        <Engine1 dataSource={dataSource} />
                    </div> */}
                    {dataEngine.map((item, key) => (
                        <Engine1 key={key} dataSource={item} />
                    ))}
                    {/* <Engine1 dataSource={groupedData} /> */}

                    {/* <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
                        <div className="flex items-center space-x-3 mb-4">
                            <div className="w-8 h-8 bg-orange-500/20 rounded-lg flex items-center justify-center">
                                <HiLightningBolt className="w-4 h-4 text-orange-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900">Engine 2</h3>
                                <p className="text-sm text-gray-600">RPM and temperature monitoring</p>
                            </div>
                        </div>
                        <Engine2 dataSource={dataSource} />
                    </div> */}
                </div>

                {/* Fuel Level Sensors */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {dataLevel.length > 0 && dataLevel.map((item, key) => (
                        <FuelLevel1 key={key} dataSource={item} />
                    ))}
                </div>

                {/* Inclination Sensor */}
                {dataSource.length > 0 && (
                    <Inclino dataSource={dataSource} />
                )}
            </div>
        </div>
    );
};

export default Sensor;
